import { CoverageProvider, useCoverage } from "./context/CoverageContext";
import { CoverageKpiCards } from "./components/CoverageKpiCards";
import { BestNextWins } from "./components/BestNextWins";
import { HubLandscapeGrid } from "./components/HubLandscapeGrid";
import { HubDetailPanel } from "./components/HubDetailSheet";
import { GenerateOutputDialog } from "./components/GenerateOutputDialog";
import { CoverageFilterBar } from "./components/CoverageFilterBar";
import { ProductivityChart } from "./components/ProductivityChart";
import {
  ResizablePanelGroup,
  ResizablePanel,
  ResizableHandle,
} from "@/modern/components/ui/resizable";

const CoverageViewContent = () => {
  const { selectedHub } = useCoverage();

  return (
    <div className="coverage-page flex flex-col h-full w-full overflow-hidden bg-background">
      <div className="shrink-0 px-5 pt-5">
        <CoverageKpiCards />
      </div>

      <div className="flex flex-1 min-h-0 px-5 pb-3 gap-3">
        <div className="flex flex-col min-h-0 w-96 shrink-0 gap-3">
          <div className="shrink-0">
            <ProductivityChart />
          </div>
          <div className="flex-1 min-h-0 overflow-hidden flex flex-col rounded-xl border border-border">
            <BestNextWins />
          </div>
        </div>

        <ResizablePanelGroup orientation="horizontal" className="flex-1 min-w-0">
          <ResizablePanel id="coverage-hub-list" maxSize={"75%"}>
            <div className="flex flex-col h-full overflow-hidden pr-2.5">
              <div className="shrink-0">
                <CoverageFilterBar />
              </div>
              <div className="flex-1 min-h-0 overflow-y-auto">
                <HubLandscapeGrid />
              </div>
            </div>
          </ResizablePanel>

          {selectedHub && (
            <>
              <ResizableHandle withHandle />
              <ResizablePanel
                id="coverage-detail"
                defaultSize={"45%"}
                maxSize={"65%"}
              >
                <div className="h-full overflow-hidden flex flex-col rounded-xl border border-border ml-3.5">
                  <HubDetailPanel />
                </div>
              </ResizablePanel>
            </>
          )}
        </ResizablePanelGroup>
      </div>

      <GenerateOutputDialog />
    </div>
  );
};

const CoverageView = () => {
  return (
    <CoverageProvider>
      <CoverageViewContent />
    </CoverageProvider>
  );
};

export default CoverageView;
